import { createColumnHelper } from "@tanstack/react-table";
import { Checkbox } from "@mui/material";
import { Eye } from "lucide-react";

const columnHelper = createColumnHelper<any>();

export const PresidentOverviewCauseListColumns = [
  columnHelper.accessor("sn", {
    header: "SN",
    cell: ({ row }) => (
      <Checkbox
        color="success"
        checked={row.getIsSelected()}
        onChange={row.getToggleSelectedHandler()}
        sx={{
          color: "#E0E0E0",
          "&.Mui-checked": {
            color: "#00B074",
          },
        }}
      />
    ),
  }),
  columnHelper.accessor("date", {
    header: "Date",
    cell: (info) => <span className="text-[#667085]">{info.getValue()}</span>,
  }),
  columnHelper.accessor("title", {
    header: "Title",
    cell: (info) => (
      <span className="text-[#101828] font-medium">
        {info.getValue()}
      </span>
    ),
  }),
  columnHelper.accessor("details", {
    header: "Details",
    cell: (info) => (
      <button className="flex items-center gap-1 text-[#101828] hover:text-[#00B074]">
        <span>View</span>
        <Eye className="w-4 h-4" />
      </button>
    ),
  }),
  columnHelper.accessor("task_title", {
    header: "Task title",
    cell: (info) => (
      <span className="text-[#98A2B3]">
        {info.getValue() || "———"}
      </span>
    ),
  }),
  columnHelper.accessor("appeal_number", {
    header: "Appeal number",
    cell: (info) => (
      <span className="text-[#101828]">
        {info.getValue()}
      </span>
    ),
  }),
  columnHelper.accessor("status", {
    header: "Status",
    cell: (info) => (
      <button className="text-[#00B074] text-sm font-medium">
        {info.getValue()}
      </button>
    ),
  }),
];

